import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const getHeaders = () => {
    const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
    const headers = {};
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }
    return headers;
};

export async function getGoogleConfig() {
    try {
        const response = await axios.get(`${API_BASE}/api/google-leads/google/config`, {
            headers: getHeaders(),
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Failed to fetch Google Lead Ads config');
    }
}

export async function listGoogleAdsAccounts(payload) {
    try {
        const response = await axios.post(`${API_BASE}/api/google-leads/google/accounts`, payload, {
            headers: getHeaders(),
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Failed to list Google Ads accounts');
    }
}

export async function connectGoogleLead(payload) {
    try {
        const response = await axios.post(`${API_BASE}/api/google-leads/google/connect`, payload, {
            headers: getHeaders(),
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Failed to connect Google Lead Ads');
    }
}

export async function getGoogleLeadIntegrations() {
    try {
        const response = await axios.get(`${API_BASE}/api/google-leads/google/integrations`, {
            headers: getHeaders(),
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Failed to fetch Google Lead integrations');
    }
}

export async function disconnectGoogleLead(id) {
    try {
        const response = await axios.delete(`${API_BASE}/api/google-leads/google/${id}`, {
            headers: getHeaders(),
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Failed to disconnect Google Lead Ads');
    }
}

export async function syncGoogleLeadNow(id, payload) {
    try {
        const response = await axios.post(`${API_BASE}/api/google-leads/google/sync/${id}`, payload, {
            headers: getHeaders(),
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Failed to sync Google Lead Ads');
    }
}

export async function updateGoogleLeadAssignment(id, payload) {
    try {
        const response = await axios.patch(`${API_BASE}/api/google-leads/google/${id}/assignment`, payload, {
            headers: getHeaders(),
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Failed to update Google Lead assignment pool');
    }
}
